import { Icon, IconProps } from '@chakra-ui/react';
import React from 'react';
import { JSX } from 'react/jsx-runtime';

const Filter = (
  props: JSX.IntrinsicAttributes &
    Omit<
      React.SVGProps<SVGSVGElement>,
      'as' | 'translate' | keyof IconProps
    > & { htmlTranslate?: 'yes' | 'no' | undefined } & IconProps & {
      as?: 'svg' | undefined;
    }
) => {
  return (
    <Icon
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      {...props}
    >
      <polygon points='22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3'></polygon>
    </Icon>
  );
};

export default Filter;
